import React, { useCallback, useState } from 'react';

import { Button } from 'primereact/button';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import { KeyFilterType } from 'primereact/keyfilter';

import './styles/SearchInputWithClear.css';

interface SearchInputWithClearProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  showClearOnHover?: boolean;
  keyfilter?: KeyFilterType;
  isMobile?: boolean;
}

const SearchInputWithClear: React.FC<SearchInputWithClearProps> = ({
  value = '',
  onChange,
  placeholder = 'Поиск по ключевым словам',
  disabled = false,
  keyfilter,
  isMobile
}) => {
  const [inputValue, setInputValue] = useState(value);

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value;
      setInputValue(newValue);
      onChange(newValue);
    },
    [onChange]
  );

  const handleClear = useCallback(() => {
    setInputValue('');
    onChange('');
  }, [onChange]);

  const hasValue = inputValue.length > 0;

  return (
    <div
      style={{
        position: 'relative',
        display: isMobile ? 'block' :  'inline-block',
        width: isMobile ? '100%' : 'auto'
      }}
    >
      <IconField iconPosition="left">
        <InputIcon className="pi pi-search"> </InputIcon>
        <InputText 
          style={{
            width: '100%',
            paddingRight: '2.5rem',
            paddingTop: 0,
            paddingBottom: 0,
            height: '42px'
          }}
          value={inputValue}
          onChange={handleInputChange}
          placeholder={placeholder}
          keyfilter={keyfilter}
        />
      </IconField>
      {hasValue && (
        <Button
          icon="pi pi-times"
          text
          severity="danger"
          aria-label="Очистить"
          onClick={handleClear}
          disabled={disabled}
          className="clear-icon"
        />
      )}
    </div>
  );
};

export default React.memo(SearchInputWithClear);
